/** Encabezado de sección reutilizable: antetítulo, título y texto opcional. */
export function SectionHeading({ eyebrow, title, text, id }: { eyebrow: string; title: string; text?: string; id: string }) {
  return (
    <div className="ix-heading">
      <p className="ix-eyebrow">{eyebrow}</p>
      <h2 id={`${id}-title`}>{title}</h2>
      {text ? <p className="ix-lead">{text}</p> : null}
    </div>
  );
}
